import type { WindowDragPhase } from "./useDragDraft";
import type { WindowPart } from "./windowSpan.lib";

/** Set on the window layer as `--window-stroke`. */
export const WINDOW_STROKE_PX = 1.5;

export const WINDOW_PART_ATTRIBUTE = "data-window-part";
export const toWindowPart = (mode: WindowPart) =>
    mode === "move" ? "body" : mode;
export const toPartSelectors = (modes: WindowPart[]) =>
    modes
        .map((mode) => `[${WINDOW_PART_ATTRIBUTE}="${toWindowPart(mode)}"]`)
        .join(", ");
const WINDOW_HANDLE_SELECTOR = toPartSelectors(["start", "end"]);
/** Every part of the window: its outlined body and both handles. */
export const WINDOW_PART_SELECTOR = `[${WINDOW_PART_ATTRIBUTE}]`;
export const WINDOW_BODY_SELECTOR = toPartSelectors(["move"]);
/** The window while it's dragged or easing into place after a drop. */
export const WINDOW_MOVING_SELECTOR = (
    ["dragging", "settling"] satisfies WindowDragPhase[]
)
    .map((phase) => `[data-window-phase="${phase}"]`)
    .join(", ");

/** Whether `target` is on one of the window's edge handles. */
export const isWindowHandle = (target: EventTarget): boolean =>
    target instanceof Element &&
    target.closest(WINDOW_HANDLE_SELECTOR) !== null;
